var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("div", { staticClass: "loading-state" }, [
            _c("p", [_vm._v("Loading...")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthorized ? _c("login") : _c("div"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }